import api from '@/services/api';
import { PaginatedResponse } from '@/types/common';
import { Territory } from '@/types/territorios';

export const territoriesService = {
  async getAll(): Promise<PaginatedResponse<Territory>> {
    const response = await api.get<PaginatedResponse<Territory>>('/territories?offset=0&limit=1000');
    return response.data;
  },
};
